angular.module('BillPay')
    .controller('ErrorCtrl', function($scope, $stateParams, $translate){
        $scope.status = $stateParams.status;
        $scope.statusText = $stateParams.statusText;

        $translate('errors.' + $stateParams.errorCode, $stateParams.additionalData).then(function (translation) {
            $scope.message = translation;
        });
    });
